module.exports = __webpack_public_path__ + "img/num2.2408dea3.png";